import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'

import { GET_SALE_TYPES, convertResult } from 'app/common/api/requests/food/items/sale_types/get'

type SaleTypes = Array<ItemType>

class SaleTypesFilterDataBox extends DataBox<SaleTypes> {}

export const defaultSaleTypes: SaleTypes = []
export const saleTypesFilter = createDataBox(
  'saleTypesFilter',
  defaultSaleTypes,
  SaleTypesFilterDataBox,
)

export const defaultSaleTypesDataReceiver = async () => {
  const res = await api.request(GET_SALE_TYPES, {
    error: 'Не удалось получить данные типов продукции',
    convertions: {
      convertResult,
    },
  })
  return res || []
}

saleTypesFilter.addDataReceiver(defaultSaleTypesDataReceiver)

export const defaultSaleTypesSelection: Array<string> = []
export const saleTypesFilterSelection = createDataBoxDefault<Array<string>>(
  'salePointsFilterSelection',
  defaultSaleTypesSelection,
)
